// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Compare_wrapper__3Q82Z","content":"Compare_content__1IHz8"};